export const FETCH_INSURANCES_REQUEST = 'FETCH_INSURANCES_REQUEST';
export const FETCH_INSURANCES_SUCCESS = 'FETCH_INSURANCES_SUCCESS';
export const FETCH_INSURANCES_FAILURE = 'FETCH_INSURANCES_FAILURE';

export const CREATE_INSURANCE_REQUEST = 'CREATE_INSURANCE_REQUEST';
export const CREATE_INSURANCE_SUCCESS = 'CREATE_INSURANCE_SUCCESS';
export const CREATE_INSURANCE_FAILURE = 'CREATE_INSURANCE_FAILURE';

export const UPDATE_INSURANCE_REQUEST = 'UPDATE_INSURANCE_REQUEST';
export const UPDATE_INSURANCE_SUCCESS = 'UPDATE_INSURANCE_SUCCESS';
export const UPDATE_INSURANCE_FAILURE = 'UPDATE_INSURANCE_FAILURE';

export const DELETE_INSURANCE_REQUEST = 'DELETE_INSURANCE_REQUEST';
export const DELETE_INSURANCE_SUCCESS = 'DELETE_INSURANCE_SUCCESS';
export const DELETE_INSURANCE_FAILURE = 'DELETE_INSURANCE_FAILURE';

export const fetchInsurancesRequest = (projectId, options = {}) => {
    const { page = 1, limit = 1, search = '' } = options;
    return {
      type:FETCH_INSURANCES_REQUEST,
      payload: { projectId, page, limit, search },
    };
  }; 
export const fetchInsurancesSuccess = (insurances) => ({ type: FETCH_INSURANCES_SUCCESS, payload: insurances });
export const fetchInsurancesFailure = (error) => ({ type: FETCH_INSURANCES_FAILURE, payload: error });

export const createInsuranceRequest = (data, projectId) => ({ type: CREATE_INSURANCE_REQUEST, payload: { data, projectId } });
export const createInsuranceSuccess = (insurance) => ({ type: CREATE_INSURANCE_SUCCESS, payload: insurance });
export const createInsuranceFailure = (error) => ({ type: CREATE_INSURANCE_FAILURE, payload: error });

export const updateInsuranceRequest = (id, data,projectId) => ({ type: UPDATE_INSURANCE_REQUEST, payload: { id, data,projectId } });
export const updateInsuranceSuccess = (insurance) => ({ type: UPDATE_INSURANCE_SUCCESS, payload: insurance });
export const updateInsuranceFailure = (error) => ({ type: UPDATE_INSURANCE_FAILURE, payload: error });

export const deleteInsuranceRequest = (id,projectId) => ({ type: DELETE_INSURANCE_REQUEST, payload: {id,projectId} });
export const deleteInsuranceSuccess = (id) => ({ type: DELETE_INSURANCE_SUCCESS, payload: id });
export const deleteInsuranceFailure = (error) => ({ type: DELETE_INSURANCE_FAILURE, payload: error });
